import React from 'react';

import AccountsSettingsSimplifiIcon from 'assets/icons/settings-menu/accounts.settings.simplifi.inline.svg';
import BusinessSettingsIcon from 'assets/icons/settings-menu/business.inline.svg';
import CategoriesTagsSettingsSimplifiIcon from 'assets/icons/settings-menu/categories.tags.settings.simplifi.inline.svg';
import NotificationsSettingsSimplifiIcon from 'assets/icons/settings-menu/notifications.settings.simplifi.inline.svg';
import ProfileOutlineSimplfiIcon from 'assets/icons/settings-menu/profile.settings.simplifi.inline.svg';
import RecurringSettingsSimplifiIcon from 'assets/icons/settings-menu/recurring.settings.simplifi.inline.svg';
import RenamingRulesSettingsSimplifiIcon from 'assets/icons/settings-menu/renaming.rules.settings.simplifi.inline.svg';
import SecuritiesSettingsSimplifiIcon from 'assets/icons/settings-menu/securities.settings.simplifi.inline.svg';
import SharingSettingsIcon from 'assets/icons/settings-menu/sharing.inline.svg';
import TransctionIcon from 'assets/icons/settings-menu/transactions.settings.simplifi.inline.svg';
import TransferActivityIcon from 'assets/icons/settings-menu/transfer.inline.svg';

import ConnectedAiSettings from 'containers/ConnectedAiSettings';
import RecurringComponent from 'containers/Recurring';
import AccountsComponent from 'containers/Settings/ChildPages/Accounts';
import BusinessComponent from 'containers/Settings/ChildPages/Businesses';
import CategoriesTagsComponent from 'containers/Settings/ChildPages/CategoriesTagsSettings';
import GeneralComponent from 'containers/Settings/ChildPages/General';
import RulesSimplifiComponent from 'containers/Settings/ChildPages/RulesSimplifi/RulesSettings';
import Securities from 'containers/Settings/ChildPages/Securities';
import TransactionsSettings from 'containers/Settings/ChildPages/TransactionsSettings';
import TransferHistory from 'containers/Settings/ChildPages/TransferHistory';

import DatasetsComponent from './ChildPages/Datasets';
import FinancesComponent from './ChildPages/Finances';
import Notifications from './ChildPages/Notifications';

export const settingsTabs = Object.freeze({
  general: {
    name: 'General',
    icon: () => <ProfileOutlineSimplfiIcon width={20} height={20} />,
    allow: 'always',
    page: () => <GeneralComponent />,
  },
  accounts: {
    name: 'Accounts',
    icon: () => <AccountsSettingsSimplifiIcon width={20} height={20} />,
    allow: 'accountEnabled',
    page: () => <AccountsComponent />,
  },
  transactionsSettings: {
    name: 'Transactions',
    icon: () => <TransctionIcon width={20} height={20} />,
    allow: 'transactionsSettings',
    page: () => <TransactionsSettings />,
  },
  businesses: {
    name: 'Businesses',
    icon: () => <BusinessSettingsIcon width={20} height={20} />,
    allow: 'businessEnabled',
    page: () => <BusinessComponent />,
  },
  categoriesTags: {
    name: 'Categories & tags',
    icon: () => <CategoriesTagsSettingsSimplifiIcon width={20} height={20} />,
    allow: 'categoriesTagsEnabled',
    page: () => <CategoriesTagsComponent />,
  },
  finances: {
    name: 'Finances',
    icon: () => <SharingSettingsIcon width={20} height={20} />,
    allow: 'financesEnabled',
    page: () => <FinancesComponent />,
  },
  notifications: {
    name: 'Notifications',
    icon: () => <NotificationsSettingsSimplifiIcon width={20} height={20} />,
    allow: 'notificationPreferences',
    page: () => <Notifications />,
  },
  Recurring: {
    name: 'All recurring',
    icon: () => <RecurringSettingsSimplifiIcon width={20} height={20} />,
    allow: 'recurringManagement',
    page: () => <RecurringComponent settingsPage />,
  },
  transactionRules: {
    name: 'Rules',
    icon: () => <RenamingRulesSettingsSimplifiIcon width={20} height={20} />,
    allow: 'transactionRules',
    page: () => <RulesSimplifiComponent />,
  },
  sharing: {
    name: 'Spaces & sharing',
    icon: () => <SharingSettingsIcon width={20} height={20} />,
    allow: 'sharingEnabled',
    page: () => <DatasetsComponent />,
  },
  connectedAi: {
    name: 'Connected AI',
    icon: () => <SharingSettingsIcon width={20} height={20} />,
    allow: 'connectedAi',
    page: () => <ConnectedAiSettings />,
  },
  transfers: {
    name: 'Transfer activity',
    icon: () => <TransferActivityIcon width={20} height={20} />,
    allow: 'a2aTransferEnabled',
    page: () => <TransferHistory />,
  },
  securities: {
    name: 'Securities',
    icon: () => <SecuritiesSettingsSimplifiIcon width={20} height={20} />,
    allow: 'securitiesEnabled',
    page: () => <Securities />,
  },
});

export type SettingsTabs = keyof typeof settingsTabs;
